module.exports = __webpack_public_path__ + "static/img/header_bg2.37780b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/header/header_bg2.png
// module id = 1Ihb
// module chunks = 1 9